import { render } from "./연혁.vue?vue&type=template&id=f88851c0"
import script from "./연혁.vue?vue&type=script&lang=js"
export * from "./연혁.vue?vue&type=script&lang=js"

import "./연혁.vue?vue&type=style&index=0&id=f88851c0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__